import React, { useState, useEffect } from "react";
import { Box, Container, makeStyles, Typography } from "@material-ui/core";
import Page from "src/components/Page";
import Form from "./Form";
import actions from "src/duck/global/actions";
import { connect } from "react-redux";
import {
  apiEndpoints,
  apiPostRequest,
  apiGetByIdRequest,
  apiGetRequest
} from "src/utils/api/api";
import { useNavigate } from "react-router-dom";
import { useParams } from "react-router";
import { kmMessages } from "src/constant/Messages";
import KmPageTitle from "src/components/layout/KmPageTitle";

const useStyles = makeStyles((theme) => ({
  root: {
    backgroundColor: theme.palette.background.dark,
    paddingBottom: theme.spacing(3),
    paddingTop: theme.spacing(3),
  },
  title: {
    marginLeft: theme.spacing(3),
  },
}));

const VotingForm = ({
  setLogoutUser,
  enableGlobalLoader,
  disableGlobalLoader,
  setVotingNoVoteCount,
  displaySnackbar,
  ...rest
}) => {
  const classes = useStyles();
  const navigate = useNavigate();
  const { votingEntryId } = useParams();
  const [voting, setVoting] = useState();

  let pageTitle = "Głosowanie";

  useEffect(() => {
    enableGlobalLoader();
    apiGetByIdRequest(
      apiEndpoints.getVotingUserDetails.path,
      votingEntryId,
      true
    )
      .then((data) => {
        disableGlobalLoader();
        setVoting(data);
      })
      .catch((error) => {
        disableGlobalLoader();
      });
    return () => {};
  }, []);

  const onSubmit = (votingId, votingOptionId) => {

    enableGlobalLoader();

    apiPostRequest(
      apiEndpoints.storeVoteForUser.path,
      {
        id: votingId,
        votingOptionId: votingOptionId,
      },
      true
    )
      .then((data) => {
        disableGlobalLoader();
        displaySnackbar({
          isOpen: true,
          severity: "success",
          autoHideDuration: 8000,
          message: kmMessages.info.voting.voteoption_votesuccessfulsaved,
        });

        apiGetRequest(apiEndpoints.getVotingInfo.path, true)
          .then((data) => {
            setVotingNoVoteCount(data.count);
            navigate("/glosowania/wtrakcie");
          })
          .catch((error) => {});

      })
      .catch((error) => {
        disableGlobalLoader();
        if (error.response && error.response.status === 401) {
          setLogoutUser();
        } else if (error.response.status === 400 && error.response.data) {
          if (error.response.data.code === "VOTING_ENDS_DATE_EXCEEDED") {
            displaySnackbar({
              isOpen: true,
              severity: "error",
              autoHideDuration: 8000,
              message: kmMessages.error.voting.voteoption_votingfinished,
            });
          }
        }
      });
  };

  return (
    <Page className={classes.root} title={pageTitle}>
      <KmPageTitle>{pageTitle}</KmPageTitle>

      <Container maxWidth={false}>
        <Box mt={3}>
          <Form onSubmit={onSubmit} voting={voting} />
        </Box>
      </Container>
    </Page>
  );
};

const mapDispatchToProps = (dispatch) => ({
  setLogoutUser: () => dispatch(actions.setLogoutUser()),
  enableGlobalLoader: () => dispatch(actions.enableGlobalLoader()),
  disableGlobalLoader: () => dispatch(actions.disableGlobalLoader()),
  displaySnackbar: (snackBarParameters) =>
    dispatch(actions.displaySnackbar(snackBarParameters)),
  setVotingNoVoteCount: (votingsNoVoteCount) =>
    dispatch(actions.setVotingNoVoteCount(votingsNoVoteCount)),
});

export default connect(null, mapDispatchToProps)(VotingForm);
